module.exports = __webpack_public_path__ + "static/media/Instagram.9ad7a2c0.png";